// src/components/financeOfficer/BudgetExpenditureChart.jsx

import React from "react";
import { FaChartLine } from "react-icons/fa";

const BudgetExpenditureChart = ({ totalBudget, totalSpend }) => {
    const percentageSpent = totalBudget > 0 ? (totalSpend / totalBudget) * 100 : 0;
    const remainingPercentage = 100 - percentageSpent;

    return (
        <div className="flex flex-col items-center">
            <div className="w-full h-8 bg-gray-200 rounded-full overflow-hidden">
                <div 
                    className="h-full bg-orange-500 transition-all duration-500 ease-in-out" 
                    style={{ width: `${Math.min(100, percentageSpent)}%` }}
                ></div>
            </div>
            <div className="w-full flex justify-between text-sm font-medium mt-2">
                <div className="text-gray-600">
                    <span className="font-bold">{percentageSpent.toFixed(1)}%</span> Spent
                </div>
                <div className="text-gray-600">
                    <span className="font-bold">{remainingPercentage.toFixed(1)}%</span> Remaining
                </div>
            </div>
        </div>
    );
};

export default BudgetExpenditureChart;